import { routes } from "./routes"
import Vue from "vue"
import VueRouter from "vue-router"
import Vuelidate from "vuelidate"
import axios from "axios"
import VuexORM from "@vuex-orm/core"
import VuexORMAxios from "@vuex-orm/plugin-axios"
import store from "@/store/index"
import Notifications from "vue-notification"
import Vuetify from "vuetify/lib"
import App from "./App.vue"
import "./utils/filters"

VuexORM.use(VuexORMAxios, {
  axios,
  headers: {
    "X-CSRF-TOKEN": window.Laravel.csrfToken,
    "X-Requested-With": "XMLHttpRequest",
  },
  baseURL: "/api/v1",
})

Vue.use(Vuelidate)
Vue.use(Notifications)
window.axios = require("axios")

window.axios.defaults.headers.common = {
  "X-CSRF-TOKEN": window.Laravel.csrfToken,
  "X-Requested-With": "XMLHttpRequest",
}

Vue.use(VueRouter)

Vue.component("app", require("./App.vue").default)

Vue.directive("can", function (el, binding) {
  return true
})

const opts = {
  icons: {
    iconfont: "mdi",
  },
  theme: {
    dark: false,
    themes: {
      light: { primary: "#2196f3", secondary: "#C5E1A5", accent: "#6A1B9A" },
      dark: {
        primary: "#2196f3",
        secondary: "#C5E1A5",
        accent: "#6A1B9A",
      },
    },
  },
}
const vuetify = new Vuetify(opts)

Vue.use(Vuetify)

new Vue({
  vuetify,
  store,
  router: new VueRouter({ routes, mode: "history" }),
  render: (h) => h(App),
}).$mount("#app")
